import React from 'react';
import styled from 'styled-components/macro';

const StyledSectionText = styled.div`
  color: black;
  font-family: Lato;
  font-weight: 400;
  font-style: normal;
  font-size: 20px;
  line-height: 32px;
  max-width: 682px;
  padding: 0 16px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: ${props =>
    props.marginBottom === 'default' ? '56px' : props.marginBottom};
`;

const SectionText = props => {
  return (
    <StyledSectionText marginBottom={props.textMarginBottom}>
      {props.sectionText}
    </StyledSectionText>
  );
};

export default SectionText;
